<template>
  <div>
    <!-- START SEARCH BAR -->
    <div class="form-search">
      <div class="date">
        {{ i18nJS.drugs_preparations.index.date }}
        <datepicker :value="date" @input="changedDate" id="date_Preparation" />
      </div>
      <div v-show="showActionButtons" class="cta">
        <i
          class="btn btn-medium fa fa-circle-check green js-tooltip"
          :data-title="i18nJS.drugs_preparations.index.tooltips.prepare_all"
          @click="prepare_all"
        ></i>
        <i
          class="btn btn-medium fa fa-circle-xmark red js-tooltip"
          :data-title="i18nJS.drugs_preparations.index.tooltips.unprepare_all"
          @click="unprepare_all"
        ></i>
      </div>
      <div v-if="strutturaResidenziale" class="sort">
        <div v-if="!isMobile" class="span4">{{ i18nJS.order_by_label }}</div>
        <div class="span4 btn-group" id="tab">
          <div :class="['btn', 'btn-small', { active: sort !== 'roombed' }]" @click="sort = 'anagraphic'">
            <fa-icon :icon-name="'fa-user'" :no-theme="true" />
            <span v-if="!isMobile"> {{ i18nJS.fullname }}</span>
          </div>
          <div :class="['btn', 'btn-small', { active: sort === 'roombed' }]" @click="sort = 'roombed'">
            <fa-icon :icon-name="'fa-bed'" :no-theme="true" />
            <span v-if="!isMobile"> {{ i18nJS.roombed_label }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- END SEARCH BAR -->
    <hr />
    <!-- START THERAPIES -->
    <component :is="showComponent" :guests="sortedGuest" :selected="guestSelected" v-if="guestPreparations && guestPreparations.length">
      <template slot-scope="guest">
        <guest-tab :guest="guest" />
      </template>
      <guest-preparations
        slot="content"
        v-if="guestSelected"
        :allergies-url="allergiesUrl"
        :guest="guestSelected"
        :preparations.sync="guestPreparations"
        :bugiardino-link="bugiardinoLink"
        :time-id="timeId"
        :manage-therapy="manageTherapies"
        :therapies-xp-enabled="therapiesXpEnabled"
        :confirmed-therapy-enabled="confirmedTherapyEnabled"
        :date="date"
        :time="time"
        :is-mobile="isMobile"
        :principio-attivo="principioAttivo"
        :can-Preparation="canPreparation"
        :can-print="canPrint"
        :group-by="groupBy"
      />
    </component>

    <div class="hero-unit" v-else>
      <p class="text-info">{{ i18nJS.drugs_preparations.index.no_preparations.replace('%{date}', '') }} {{ date }}</p>
      <div v-if="canGeneratePrep" class="text-info" :data_check_ko_message="generationFailedMsg" id="generate_preparations_div">
        {{ i18nJS.drugs_preparations.index.generate_preparations_msg }}
        <!--<%= link_to t('click_here'), generate_preparations_therapies_path(date: @date), remote: true, method: :post %> -->
      </div>
    </div>

    <!--- END THERAPIES -->
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import guestTab from '../guestTab';
import faIcon from '../faIcon';
import vSelect2 from '../vSelect2';
import datepicker from '../datepicker';
import guestPreparations from './guestPreparations';
import tabPreparations from './tabPreparations';
import collapsePreparations from './collapsePreparations';

export default {
  name: 'drugsPreparations',
  props: [
    'urlItems',
    'loadDate',
    'strutturaResidenziale',
    'urlPreparation',
    'bugiardinoLink',
    'manageTherapies',
    'therapiesXpEnabled',
    'time',
    'timeId',
    'defaultOrder',
    'canPrint',
    'principioAttivo',
    'canPreparation',
    'confirmedTherapyEnabled',
    'groupBy',
  ],
  components: {
    vSelect2,
    faIcon,
    guestTab,
    datepicker,
    tabPreparations,
    guestPreparations,
    collapsePreparations,
  },
  data() {
    return {
      guests: [],
      sort: null,
      guestSelected: null,
      allergiesUrl: null,
      guestPreparations: {},
      isMobile: false,
      windowWidth: window.innerWidth,
      date: moment().format(i18nJS.time.formats.date_only),
    };
  },
  computed: {
    sortedGuest() {
      if (this.guests) {
        const guestOrdered = [...this.guests];
        return guestOrdered.sort(this.compare);
      } else {
        return [];
      }
    },
    canGeneratePrep() {
      return (
        this.canPreparation &&
        (this.date == moment().format(i18nJS.time.formats.date_only) ||
          this.date == moment().add(1, 'days').format(i18nJS.time.formats.date_only))
      );
    },
    generationFailedMsg() {
      return i18nJS.drugs_preparations.index.generation_failed;
    },
    i18nJS() {
      return window.i18nJS;
    },
    showActionButtons() {
      return this.guestPreparations?.length && moment(this.date, i18nJS.time.formats.date_only) > new Date();
    },
    showComponent() {
      return this.isMobile ? 'collapse-preparations' : 'tab-preparations';
    },
  },
  watch: {
    windowWidth: {
      immediate: true,
      handler(val) {
        this.isMobile = val <= 1000;
      },
    },
    date: function value(val) {
      this.changeHrefReport('date', val);
      this.loadGuest();
    },
    sort: {
      immediate: true,
      handler() {
        this.guestSelected = this.sortedGuest[0];
      },
    },
    guestSelected: function value(newVal) {
      Loader.show();
      this.guestPreparations = null;
      this.allergiesPath(newVal.id);
      if (newVal) {
        let newUrl = this.urlPreparation
          .replace('__GUEST_PERIOD_DATA_SET_ID__', newVal.id)
          .replace('__DATE__', this.date.replaceAll('/', '%2F'));
        apiConnector()
          .get(newUrl)
          .then(({ data }) => {
            this.guestPreparations = data;
            Loader.hide();
          });
      }
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
    this.date = this.loadDate || moment().format(i18nJS.time.formats.date_only);
    this.$on('guestSelected', (guest) => (this.guestSelected = guest));
    this.loadGuest();
    window.DatePKR.init();

    Loader.show();
  },
  methods: {
    allergiesPath(gpds_id) {
      this.allergiesUrl =
        window.config.ePersonamService.ePersonamHost +
        '/it/guest_period_data_sets/' +
        gpds_id +
        '/guest_allergies?guest_period_data_set_id=' +
        gpds_id;
    },
    changedDate(val) {
      this.date = val;
      this.loadGuest();
    },
    changeHrefReport(paramName, val) {
      let url = $('#print-therapies').prop('href');
      url = Utils.addGetParam(url, paramName, val);
      $('#print-therapies').prop('href', url);
    },
    loadGuest() {
      let newUrl = Utils.addGetParam(this.urlItems, 'date', this.date);
      apiConnector()
        .get(newUrl)
        .then(({ data }) => {
          this.guests = data;
          if (this.guests.length === 0) {
            Loader.hide();
          }
          if (!this.sort) {
            this.sort = this.defaultOrder;
          } else {
            this.guestSelected = this.sortedGuest[0];
          }
          window.Utils.pushState(window.Utils.addGetParam(window.location.href, 'date', this.date));
        })
        .catch((err) => {
          console.log('Could not set initial value', err);
        });
    },
    prepare_all() {
      const url = `${this.manageTherapies}/${this.date.replaceAll('/', '%2F')}/all/true.json`;
      Loader.show();
      apiConnector()
        .patch(url)
        .then(({ data }) => {
          this.loadGuest();
        })
        .catch((err) => {
          Loader.hide();
          console.log('Could not prepare all', err);
        });
    },
    unprepare_all() {
      const url = `${this.manageTherapies}/${this.date.replaceAll('/', '%2F')}/all/false.json`;
      Loader.show();
      apiConnector()
        .patch(url)
        .then(({ data }) => {
          this.loadGuest();
        })
        .catch((err) => {
          Loader.hide();
          console.log('Could not unprepare all', err);
        });
    },
    showTherapies(guest) {
      this.guestSelected = guest;
    },
    compare(a, b) {
      if (this.sort === 'roombed') {
        if (a.room_bed_label < b.room_bed_label) return -1;
        if (a.room_bed_label > b.room_bed_label) return 1;
        return 0;
      } else {
        if (a.full_name < b.full_name) return -1;
        if (a.full_name > b.full_name) return 1;
        return 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.form-search {
  display: flex;
  justify-content: space-between;
}
.sort {
  width: 25em;
}
</style>
